export default __webpack_public_path__ + "static/media/Satyanarayan Behera.62d3fa6e.JPG";